export interface RouteObservationsQueryArgs {
  readonly organizationUuid: string
  readonly applicationUuid: string
  readonly routeHash: string
  readonly agentSessionId?: string[]
}

interface RouteObservation {
  readonly url: string
  readonly verb?: string
}

export interface RouteObservationResponse {
  readonly observations: RouteObservation[]
  readonly total: number
}

export function getRouteObservations({
  organizationUuid,
  applicationUuid,
  routeHash,
  agentSessionId
}: RouteObservationsQueryArgs): Promise<RouteObservationResponse> {
  const routeObservationsURL = `/${organizationUuid}/applications/${applicationUuid}/route/${routeHash}/observations?expand=skip_links${
    agentSessionId ? `&agentSessionId=${agentSessionId}` : ''
  }`

  return this.connector.get(routeObservationsURL)
}
